import { render } from "./AppUpload.vue?vue&type=template&id=ed6c2648&ts=true"
import script from "./AppUpload.vue?vue&type=script&lang=ts"
export * from "./AppUpload.vue?vue&type=script&lang=ts"

import "./AppUpload.vue?vue&type=style&index=0&id=ed6c2648&lang=css"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__